import { useHistory, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

export function useLocationActions() {
  const location = useLocation();
  const history = useHistory();

  const onClearState = useCallback(() => {
    if (!location.state) return;

    history.replace({
      pathname: location.pathname,
      search: location.search,
      state: null,
    });
  }, [history, location.pathname, location.search, location.state]);

  return {
    onClearState,
  };
}
